// src/components/ConfirmationComponent.js
import React, { useEffect } from 'react';
import { useTranslations  } from './TranslationContext';

const ConfirmationComponent = ({ message, onConfirm, onCancel }) => {
  const { language, getTranslation } = useTranslations();

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Enter') { e.stopImmediatePropagation(); onConfirm(); onCancel(); }
      else if (e.key === 'Escape') { e.stopImmediatePropagation(); onCancel(); }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onConfirm, onCancel]);

  return (
    <div className="confirmation-overlay">
      <div className="confirmation-dialog">
        <p>{message}</p>
        <button className="btn btn-confirm hover" onClick={() => { onConfirm(); onCancel(); }}>{getTranslation("import_Yes")}</button>
        <button className="btn hover" onClick={onCancel}>{getTranslation("import_No")}</button>
      </div>
    </div>
  );
};

export default ConfirmationComponent;
